import React from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { apiInstance } from "../../../../api/api_Instance";

import styles from "./quality-from.module.css";
import { Button } from "../../../../components/ui/button/Button";
import { Link } from "react-router";
import { useHookFormMask } from "use-mask-input";
export const QualityForm = () => {

    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const registerWithMask = useHookFormMask(register);
    const mutation = useMutation({
        mutationFn: (data) => apiInstance.post("/api/send_message/", data),
        onSuccess: () => {
            reset();
        },
        onError: () => {
            alert(`Произошла ошибка`);
        }
    });

    const onSubmit = (data) => {
        const dto = {
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            phone: data.phone,
            message: data.message
        };

        mutation.mutate(dto);
    };

    return (
        <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>

            <div className={styles.field}>
                <label>Имя *</label>
                <input {...register("first_name", { required: "Введите имя" })} />
                {errors.first_name && <span className={styles.error}>{errors.first_name.message}</span>}
            </div>

            <div className={styles.field}>
                <label>Фамилия *</label>
                <input {...register("last_name", { required: "Введите фамилию" })} />
                {errors.last_name && <span className={styles.error}>{errors.last_name.message}</span>}
            </div>

            <div className={styles.field}>
                <label>Телефон *</label>
                <input
                    type="text"
                    {...registerWithMask("phone", "+7 (999) 999-99-99", {
                        required: "Введите телефон"
                    })}
                />
                {errors.phone && (
                    <span className={styles.error}>{errors.phone.message}</span>
                )}
            </div>

            <div className={styles.field}>
                <label>Эл. почта *</label>
                <input
                    type="email"
                    {...register("email", {
                        required: "Введите email",
                        pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "Введите корректный email"
                        }
                    })}
                />
                {errors.email && (
                    <span className={styles.error}>{errors.email.message}</span>
                )}
            </div>

            <div className={styles.field}>
                <label>Сообщение *</label>
                <textarea {...register("message", { required: "Введите текст сообщения" })} />
                {errors.message && <span className={styles.error}>{errors.message.message}</span>}
            </div>

            <div className={styles.checkbox}>
                <label>
                    <input
                        type="checkbox"
                        {...register("agree", { required: "Необходимо согласие" })}
                    />
                    Согласие на обработку{" "}
                    <Link className={styles.link} to="/policy" target="_blank">
                        персональных данных
                    </Link>
                </label>
                {errors.agree && (
                    <div className={styles.error}>{errors.agree.message}</div>
                )}
            </div>

            <Button type="submit" variant="yellow" disabled={mutation.isPending}>
                {mutation.isPending ? "Отправка..." : "Отправить"}
            </Button>

        </form>
    );
};
